import { useIntl } from 'react-intl';

import { TextDocument } from '@sorare/core/src/routing/TextDocument/lazy';

import { InfoLayout } from 'components/layouts/InfoLayout';

const MarketplaceTerms = () => {
  const { formatMessage } = useIntl();
  return (
    <InfoLayout>
      <TextDocument
        document={formatMessage({
          id: 'MarketplaceTerms.path',
          defaultMessage: 'MARKETPLACE_TERMS.md',
        })}
        skipHtml
      />
    </InfoLayout>
  );
};

export default MarketplaceTerms;
